import { LOAD } from 'src/config/app'
import { ASSET_TYPES } from 'src/services/ThreeService/const'
import env from 'src/config/env'

export const TEXTURE = {
  BG_EPOCH_ONE: 'BG_EPOCH_ONE',
  BG_EPOCH_TWO: 'BG_EPOCH_TWO',
  BG_EPOCH_THREE: 'BG_EPOCH_THREE',
  BG_EPOCH_FOUR: 'BG_EPOCH_FOUR',
  BG_BLACK: 'BG_BLACK',

  ENV: 'env.png',
  AO: 'ao.png',

  BODY_DIFFUSECOLOR: 'Body_DiffuseColor.png',
  BODY_METALROUGHNESS: 'Body_MetalRoughness.jpg',
  BODY_NORMAL: 'Body_Normal.png',

  BODY_FEATHERS_DIFFUSECOLOR: 'Body_feathers_DiffuseColor.png',
  BODY_FEATHERS_METALROUGHNESS: 'Body_feathers_MetalRoughness.jpg',
  BODY_FEATHERS_NORMAL: 'Body_feathers_Normal.png',

  TAIL_FEATHERS_DIFFUSECOLOR: 'Tail_feathers_DiffuseColor.png',
  TAIL_FEATHERS_METALROUGHNESS: 'Tail_feathers_MetalRoughness.jpg',
  TAIL_FEATHERS_NORMAL: 'Tail_feathers_Normal.png',

  WING_FEATHERS_DIFFUSECOLOR: 'Wing_feathers_DiffuseColor.png',
  WING_FEATHERS_METALROUGHNESS: 'Wing_feathers_MetalRoughness.jpg',
  WING_FEATHERS_NORMAL: 'Wing_feathers_Normal.png',
}

export const GLTF = {
  FOWL: 'FOWL',
}

export const fowlVersion = '10-12-2020-v3'

let DESKTOP_MANIFEST = [
  {
    id: LOAD.GROUPS.MAIN,
    items: [
      {
        id: GLTF.FOWL,
        type: ASSET_TYPES.GLTF,
        url: require(`@/assets/models/fowl/${fowlVersion}/Fowl.glb`),
      },

      {
        id: TEXTURE.ENV,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/env.basis`),
      },

      {
        id: TEXTURE.AO,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/ao.basis`),
      },

      //
      {
        id: TEXTURE.BODY_DIFFUSECOLOR,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/2048/basis/Body_DiffuseColor.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_METALROUGHNESS,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Body_MetalRoughness.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_NORMAL,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/uastc/Body_Normal.basis`),
        flipY: true,
        mipmap: false,
      },

      {
        id: TEXTURE.BODY_FEATHERS_DIFFUSECOLOR,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Body_feathers_DiffuseColor.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_FEATHERS_METALROUGHNESS,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Body_feathers_MetalRoughness.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_FEATHERS_NORMAL,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/uastc/Body_feathers_Normal.basis`),
        flipY: true,
        mipmap: false,
      },

      {
        id: TEXTURE.TAIL_FEATHERS_DIFFUSECOLOR,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Tail_feathers_DiffuseColor.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.TAIL_FEATHERS_METALROUGHNESS,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Tail_feathers_MetalRoughness.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.TAIL_FEATHERS_NORMAL,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/uastc/Tail_feathers_Normal.basis`),
        flipY: true,
        mipmap: false,
      },

      {
        id: TEXTURE.WING_FEATHERS_DIFFUSECOLOR,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Wing_feathers_DiffuseColor.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.WING_FEATHERS_METALROUGHNESS,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/basis/Wing_feathers_MetalRoughness.basis`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.WING_FEATHERS_NORMAL,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/1024/uastc/Wing_feathers_Normal.basis`),
        flipY: true,
        mipmap: false,
      },

      // BACKGROUNDS
      {
        id: TEXTURE.BG_EPOCH_ONE,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-01.basis'),
      },
      {
        id: TEXTURE.BG_EPOCH_TWO,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-02.basis'),
      },
      {
        id: TEXTURE.BG_EPOCH_THREE,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-03.basis'),
      },
      {
        id: TEXTURE.BG_EPOCH_FOUR,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-04.basis'),
      },
      {
        id: TEXTURE.BG_BLACK,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/black.basis'),
      },
    ],
  },
]

let size = 1024
let IOS_MANIFEST = [
  {
    id: LOAD.GROUPS.MAIN,
    items: [
      {
        id: GLTF.FOWL,
        type: ASSET_TYPES.GLTF,
        url: require(`@/assets/models/fowl/${fowlVersion}/Fowl.glb`),
      },

      {
        id: TEXTURE.ENV,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/env.png`),
        flipY: true,
      },

      {
        id: TEXTURE.AO,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/ao.png`),
        flipY: true,
        mipmap: false,
      },

      //
      {
        id: TEXTURE.BODY_DIFFUSECOLOR,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Body_DiffuseColor.png`),
        flipY: false,
        mipmap: false,
      },
      {
        id: TEXTURE.BODY_METALROUGHNESS,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Body_MetalRoughness.jpg`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_NORMAL,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Body_Normal.png`),
        flipY: true,
        mipmap: false,
      },

      {
        id: TEXTURE.BODY_FEATHERS_DIFFUSECOLOR,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Body_feathers_DiffuseColor.png`),
        flipY: false,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_FEATHERS_METALROUGHNESS,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Body_feathers_MetalRoughness.jpg`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.BODY_FEATHERS_NORMAL,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Body_feathers_Normal.png`),
        flipY: true,
        mipmap: true,
      },

      {
        id: TEXTURE.TAIL_FEATHERS_DIFFUSECOLOR,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Tail_feathers_DiffuseColor.png`),
        flipY: false,
        mipmap: true,
      },
      {
        id: TEXTURE.TAIL_FEATHERS_METALROUGHNESS,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Tail_feathers_MetalRoughness.jpg`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.TAIL_FEATHERS_NORMAL,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Tail_feathers_Normal.png`),
        flipY: true,
        mipmap: true,
      },

      {
        id: TEXTURE.WING_FEATHERS_DIFFUSECOLOR,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Wing_feathers_DiffuseColor.png`),
        flipY: false,
        mipmap: true,
      },
      {
        id: TEXTURE.WING_FEATHERS_METALROUGHNESS,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Wing_feathers_MetalRoughness.jpg`),
        flipY: true,
        mipmap: true,
      },
      {
        id: TEXTURE.WING_FEATHERS_NORMAL,
        type: ASSET_TYPES.TEXTURE,
        url: require(`@/assets/models/fowl/${fowlVersion}/${size}/img/Wing_feathers_Normal.png`),
        flipY: true,
        mipmap: true,
      },

      // BACKGROUNDS
      {
        id: TEXTURE.BG_EPOCH_ONE,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-01.basis'),
        flipY: true,
      },
      {
        id: TEXTURE.BG_EPOCH_TWO,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-02.basis'),
        flipY: true,
      },
      {
        id: TEXTURE.BG_EPOCH_THREE,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-03.basis'),
        flipY: true,
      },
      {
        id: TEXTURE.BG_EPOCH_FOUR,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/BG-04.basis'),
        flipY: true,
      },
      {
        id: TEXTURE.BG_BLACK,
        type: ASSET_TYPES.BASIS_TEXTURE,
        url: require('@/assets/imgs/bg/black.basis'),
        flipY: true,
      },
    ],
  },
]

let manifest = env.desktop ? DESKTOP_MANIFEST : IOS_MANIFEST // DESKTOP_MANIFEST
export default manifest
